export const CHANGE_CURRENT_PAGE = 'DTGSizes/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'DTGSizes/CHANGE_PAGE_SIZE'
export const CREATE_DTG_SIZE = 'DTGSizes/CREATE'
export const FETCH_DTG_SIZE_LIST = 'DTGSizes/FETCH_LIST'
export const FETCH_DTG_SIZE_FOR_OPTIONS = 'DTGSizes/FETCH_FOR_OPTIONS'
export const REMOVE_DTG_SIZE = 'DTGSizes/REMOVE'
